import { IAnalyticsEvent } from '@verv-inc/js-toolkit';

interface GTMEventPurchaseParameters {
	value: number;
	product: string;
	email: string;
}

interface GTMEventPaymentDeclineParameters {
	declineReason: string | null;
	declineSystem: string;
}

export const GTMEvent = {
	purchase: (parameters: GTMEventPurchaseParameters): IAnalyticsEvent => {
		return {
			name: 'gtm-purchase',
			info: {
				event_purchase: 'purchase',
				...parameters,
			},
		};
	},
	show3dsPopup: (): IAnalyticsEvent => {
		return {
			name: 'show-3ds-popup',
		};
	},
	paymentDecline: (parameters: GTMEventPaymentDeclineParameters): IAnalyticsEvent => {
		return {
			name: 'payment-decline',
			info: {
				decline_reason: parameters.declineReason,
				decline_system: parameters.declineSystem,
			},
		};
	},
};
